export const propMiscModals = {
  policia: {
    title: "Dane rejestracyjne",
    heading: "Wprowadź dane właściwych organów",
    subtitle:
      "Automatyczna synchronizacja check-in w obiekcie z właściwymi organami",
    entityLabel: "Nazwa instytucji",
    entityPlaceholder: "Wybierz instytucję",
    userLabel: "Nazwa użytkownika",
    passwordLabel: "Hasło",
    accessError:
      "Proszę sprawdzić dane dostępowe. Zalecamy nie ponawiać próby więcej niż trzy razy, ponieważ konto może zostać zablokowane.",
    validateBtn: "Zweryfikuj",
    saveBtn: "Zapisz dane",
    entityRequired: "Instytucja jest wymagana",
    usernameRequired: "Nazwa użytkownika jest wymagana",
    passwordRequired: "Należy podać hasło",
    validateError: "Błąd podczas weryfikacji danych",
    saveError: "Błąd zapisu danych policji imigracyjnej",
  },
  upgrade: {
    heading: "Podnieś plan, aby dalej tworzyć obiekty",
    message:
      "Dzień dobry! Zauważyliśmy, że osiągnięto limit obiektów dostępnych w obecnym planie.",
    button: "Podnieś plan",
  },
};
